/* 4DELTAS V8 Customize inquiry modal. No dependencies and safe on theme editor reload. */
(() => {
  if (window.__fgV8CustomizeReady) return;
  window.__fgV8CustomizeReady = true;
  let lastTrigger = null;
  let priorOverflow = '';
  const getModal = () => document.querySelector('[data-fg-v8-customize-modal]');
  const getPanel = () => getModal()?.querySelector('.fg-v8-customize__panel');
  const close = () => {
    const modal = getModal();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = priorOverflow;
    lastTrigger?.focus?.();
  };
  const open = (trigger) => {
    const modal = getModal();
    if (!modal) return;
    lastTrigger = trigger;
    priorOverflow = document.body.style.overflow;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const status = modal.querySelector('[data-fg-v8-customize-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
    getPanel()?.focus();
  };
  const message = (modal) => {
    const selected = modal.querySelector('input[name="fg_v8_custom_type"]:checked');
    const notes = modal.querySelector('#fg-v8-customize-notes')?.value.trim() || '';
    const title = modal.querySelector('.fg-v8-customize__preview span:last-child')?.textContent.trim() || '';
    const lines = ['Hello 4DELTAS, I would like to request customization.', `Customization: ${selected?.value || 'Other'}`];
    if (title) lines.push(`Product: ${title}`);
    if (notes) lines.push(`Details: ${notes}`);
    return lines.join('\n');
  };
  const error = (modal, text) => {
    const status = modal.querySelector('[data-fg-v8-customize-status]');
    if (status) { status.textContent = text; status.hidden = false; }
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-fg-v8-customize-trigger]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    const modal = getModal();
    if (!modal || modal.hidden) return;
    if (event.target.closest?.('[data-fg-v8-customize-close]')) { close(); return; }
    if (event.target.closest?.('[data-fg-v8-customize-whatsapp]')) {
      const phone = (modal.dataset.fgV8Whatsapp || '').replace(/\D/g, '');
      if (!phone) { error(modal, 'WhatsApp number is not yet configured. Please choose Email or add a WhatsApp number in Theme settings.'); return; }
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message(modal))}`, '_blank', 'noopener,noreferrer');
      return;
    }
    if (event.target.closest?.('[data-fg-v8-customize-email-action]')) {
      const email = (modal.dataset.fgV8Email || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { error(modal, 'Please configure a valid contact email address in Theme settings.'); return; }
      const subject = '4DELTAS - Customization Inquiry';
      window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message(modal))}`;
    }
  });
  document.addEventListener('input', (event) => {
    if (event.target?.id !== 'fg-v8-customize-notes') return;
    const counter = getModal()?.querySelector('[data-fg-v8-customize-counter]');
    if (counter) counter.textContent = `${event.target.value.length} / 1600`;
  });
  document.addEventListener('keydown', (event) => {
    const modal = getModal();
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(getPanel().querySelectorAll('button:not([disabled]), input:not([disabled]), textarea:not([disabled]), a[href]'));
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable[focusable.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) { event.preventDefault(); focusable[0].focus(); }
  });
})();
